import type { MatchState } from '../match/MatchState';
import { TacticalPositioning } from './TacticalPositioning';
import { TeamAIDirector } from './TeamAIDirector';

export class TacticalAI {
  constructor(
    private readonly director = new TeamAIDirector(),
    private readonly positioning = new TacticalPositioning(),
  ) {}

  updateMovementIntent(state: MatchState): void {
    this.director.update(state);
    this.positioning.update(state, true);
  }
}
